'use client';

import { Title } from '@mantine/core';
import LayananGrid from '../../LayananGrid';
import ProductGrid from '../../ProductGrid';

export function HomeGrid() {
  return (
    <div>
      <Title
        order={2}
        className="text-gray-800"
        fz={{ base: 'lg', sm: 20, md: 25 }}
      >
        Rekomendasi Produk
      </Title>
      <ProductGrid />
      <Title
        order={2}
        className="text-gray-800"
        fz={{ base: 'lg', sm: 20, md: 25 }}
      >
        Rekomendasi Layanan
      </Title>
      <LayananGrid />
    </div>
  );
}
